export default function getDimensionsConstrainedToContainer(
    elementDimensions,
    containerDimensions
) {
    var widthScale;
    var heightScale;
    var scale;

    if (
        elementDimensions.width < containerDimensions.width &&
        elementDimensions.height < containerDimensions.height
    ) {
        return elementDimensions;
    }

    widthScale = containerDimensions.width / elementDimensions.width;
    heightScale = containerDimensions.height / elementDimensions.height;
    scale = Math.min(widthScale, heightScale);

    return {
        width: parseInt(elementDimensions.width * scale, 10),
        height: parseInt(elementDimensions.height * scale, 10),
    };
}



// WEBPACK FOOTER //
// ./~/@99designs/utils/dom/getDimensionsConstrainedToContainer.js